var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ac-dynamic',{attrs:{"props":{list: ['list', 'of', 'options'], switchoff: false, value: _vm.dynamic.value},"props_mapper":{
              list: 'options',
              switchoff: 'disabled',
              testing: 'someprop',
              value: 'value'
            },"component_name":"VueMultiselect","url":['https://unpkg.com/vue-multiselect@2.1.0/dist/vue-multiselect.min.css', 'https://unpkg.com/vue-multiselect@2.1.0']},on:{"select":_vm.handleChangeDynamic}})}
var staticRenderFns = []

export { render, staticRenderFns }